import axios from "axios";
import { SubFinanceType } from "models/sub_finance_category";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useSubCategory = () => {
  const [lista, setAccountTypeList] = useState<SubFinanceType[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<SubFinanceType>(null);
  const nomeRef = useRef(null);
  const deptoRef = useRef(null);
  const cancelRef = useRef();

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      nomeRef.current = null;
      setAccountSelected(null);
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/finance-sub-category/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  }

  const add = () => {
    showModal(true);
  };

  const save = async () => {
    if (nomeRef.current !== null && deptoRef.current !== null) {
      setError(false);
      if (!accountSelected) {
        await addRegister();
      } else {
        await updateRegister();
      }
      await loadData();
    } else {
      setError(true);
    }
  };

  const addRegister = async () => {

    const obj = {
        nome: nomeRef.current,
        categoriaLancamentoId: deptoRef.current,
        idEmpresa: usuario?.idEmpresa,
      };
      const response = await axios.post(process.env.REACT_APP_API_URL + "/finance-sub-category/", obj);
      if (response.data) {
        setLoading((prev) => (prev = false));
        showModal(false);
        nomeRef.current = null;
        deptoRef.current = null;
        setAccountSelected(null);
      }

  }

  const updateRegister = async () => {
    console.log(nomeRef.current.value, 'nomeRef.current.value');
    const obj = {
        id: accountSelected.id,
        nome: nomeRef.current.value !== undefined ? nomeRef.current.value : nomeRef.current,
        categoriaLancamentoId: deptoRef.current.value !== undefined ? deptoRef.current.value : deptoRef.current,
        idEmpresa: usuario?.idEmpresa,
      };
      const response = await axios.patch(
        process.env.REACT_APP_API_URL + "/finance-sub-category/" + accountSelected.id,
        obj
      );
      if (response.data) {
        setLoading((prev) => (prev = false));
        showModal(false);
        nomeRef.current = null;
        deptoRef.current = null;
        setAccountSelected(null);
      }
  }

  const edit = (item: SubFinanceType) => {
    showModal(true);
    setAccountSelected(item);
    nomeRef.current = item.nome;
    deptoRef.current= item.categoriaLancamentoId;
  };

  const showDeleteModal = (item: SubFinanceType) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/finance-sub-category/" + accountSelected?.id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      showModal(false);
      nomeRef.current = null;
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  useEffect(() => {
     const initialize = async () => {
        await loadData();
     }
     initialize();
  }, []);
  return {
    lista,
    add,
    edit,
    loading,
    show,
    showModal,
    nomeRef,
    accountSelected,
    error,
    save,
    deletar,
    showDeleteModal,
    showDelete,
    cancelRef,
    closeDelete,
    deptoRef
    
  }
};

export default useSubCategory;
